//src/api/account.js
import request from '@/utils/request'

export default {
    getAccount(accountId) {
        return request.get('/account/' + accountId)
    },
    getAllAccount() {
        return request.get('/account/list')
    }
}